/* eslint-disable no-nested-ternary */
import React from "react";
// import GridLayout from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import { Box, Typography } from "@mui/material";
import "../styles/widget.scss";

export default function WidgetBox() {
  return (
    <Box p={2} pl={4}>
      <Typography
        variant="h6"
        color="info"
        mb={0}
        display="block"
        className="dragHandle"
        lineHeight="1rem"
      >
        Header
      </Typography>
    </Box>
  );
}
